<template>
    <div class="activity-data-manager-compact">
        <TabContainer :tabs="tabs" :activeTab.sync="activeTab">
            <template #actions="{ activeTab: currentTab }">
                <!-- 조회 탭: 내보내기, 추가 (탭 영역 맨 오른쪽) -->
                <div v-if="currentTab === 0" class="tab-actions-group tab-actions-right">
                    <!-- <button class="btn-compact btn-primary" @click="exportData">
                        <i class="fas fa-download"></i>
                        내보내기
                    </button> -->
                    <CarbonButton
                        v-if="fixedPeriod"
                        variant="primary"
                        icon="fas fa-plus"
                        @click="openEditRowModal"
                    >
                        추가
                    </CarbonButton>
                </div>

                <!-- 액션 버튼 (업로드 탭) -->
                <div class="tab-actions-group" v-if="currentTab === 1">
                    <!-- 기간 고정 noti (파일 선택 버튼 왼쪽) -->
                    <span
                        v-if="fixedPeriod"
                        class="fixed-period-noti"
                        :title="`선택한 스텝의 기간 ${formatFixedPeriod(fixedPeriod)}으로 업로드됩니다`"
                    >
                        <i class="fas fa-calendar-alt"></i>
                        {{ formatFixedPeriod(fixedPeriod) }} 업로드
                    </span>
                    <!-- 파일 선택/정보 영역 (왼쪽) -->
                    <div class="file-compact-area">
                        <!-- 파일이 없을 때: 선택 버튼 -->
                        <CarbonButton
                            v-if="!hasUploadedFile"
                            variant="fileSelect"
                            icon="fas fa-paperclip"
                            @click="triggerFileSelect"
                        >
                            파일 선택
                        </CarbonButton>
                        <!-- 파일이 있을 때: 정보 표시 -->
                        <div v-else class="file-info-compact">
                            <i class="fas fa-file-excel file-icon-small"></i>
                            <span class="file-name-small">{{ uploadedFileName }}</span>
                            <span class="file-size-small">({{ uploadedFileSize }})</span>
                            <button class="btn-icon-tiny" @click="removeFile" title="파일 제거">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!-- 기존 버튼들 (오른쪽) -->
                    <CarbonButton
                        variant="clear"
                        icon="fas fa-times"
                        :disabled="!hasUploadedFile"
                        @click="clearUploadData"
                    >
                        초기화
                    </CarbonButton>
                    <CarbonButton icon="fas fa-file-download" @click="downloadTemplate">템플릿</CarbonButton>
                </div>
            </template>
            <template #default="{ activeTab: currentTab }">
                <!-- 탭 컨텐츠 -->
                <div class="tab-content-wrapper">
                    <!-- 조회 탭 -->
                    <div v-show="currentTab === 0" class="tab-pane">
                        <ActivityDataViewer
                            ref="dataViewer"
                            :login-user="loginUser"
                            :fixed-period="fixedPeriod"
                            :fixed-org-idx="fixedOrgIdx"
                            @data-loaded="handleDataLoaded"
                        />
                    </div>

                    <!-- 업로드 탭 -->
                    <div v-show="currentTab === 1" class="tab-pane">
                        <ActivityUploader
                            ref="uploader"
                            :login-user="loginUser"
                            :fixed-period="fixedPeriod"
                            :fixed-org-idx="fixedOrgIdx"
                            @data-imported="handleDataImported"
                            @file-selected="hasUploadedFile = $event"
                        />
                    </div>
                </div>
            </template>
        </TabContainer>
    </div>
</template>

<script>
import TabContainer from "../../common/TabContainer.vue";
import ActivityDataViewer from "./ActivityDataViewer.vue";
import ActivityUploader from "../views/ActivityUploader.vue";
import CarbonButton from "../../common/CarbonButton.vue";

export default {
    name: "ActivityDataManager",
    components: {
        TabContainer,
        ActivityDataViewer,
        ActivityUploader,
        CarbonButton,
    },
    props: {
        loginUser: {
            type: Object,
            default: () => ({}),
        },
        /** 스텝 컨텍스트: 기간 고정 (YYYYMM) - 드롭다운에서 스텝 클릭 시 */
        fixedPeriod: {
            type: [String, Number],
            default: null,
        },
        /** 스텝 컨텍스트: 조직 고정 (orgIdx) */
        fixedOrgIdx: {
            type: [Number, String],
            default: null,
        },
    },
    data() {
        return {
            activeTab: 0,
            tabs: [
                { label: "활동자료 목록", value: 0 },
                { label: "활동자료 파일 업로드", value: 1 },
            ],
            hasUploadedFile: false,
            uploadedFileName: "",
            uploadedFileSize: "",
        };
    },
    watch: {
        activeTab(newVal) {
            // 조회 탭으로 전환 시 자동 새로고침
            if (newVal === 0) {
                this.$nextTick(() => {
                    this.refreshData();
                });
            }
            // 업로드 탭으로 전환 시 파일 상태 체크
            if (newVal === 1) {
                this.$nextTick(() => {
                    this.checkUploadedFile();
                });
            }
        },
        hasUploadedFile(newVal) {
            // 파일 상태 변경 시 정보 업데이트
            if (newVal) {
                this.$nextTick(() => {
                    this.checkUploadedFile();
                });
            }
        },
    },
    methods: {
        handleDataLoaded() {
            // 데이터 로드 완료 (필요 시 처리)
        },
        handleDataImported(result) {
            if (result.successCount > 0) {
                this.$bvToast.toast(`${result.created}건 생성, ${result.updated}건 업데이트`, {
                    variant: "success",
                    title: "업로드 완료",
                    toaster: "b-toaster-bottom-right",
                });

                // 자동으로 조회 탭 전환
                setTimeout(() => {
                    this.activeTab = 0;
                }, 1500);
            }

            this.$emit("data-imported", result);
        },

        // 데이터 새로고침
        refreshData() {
            if (this.$refs.dataViewer) {
                this.$refs.dataViewer.loadData();
            }
        },

        // 템플릿 다운로드
        downloadTemplate() {
            if (this.$refs.uploader) {
                this.$refs.uploader.downloadTemplate();
            }
        },

        // 활동자료 추가 모달 열기
        openEditRowModal() {
            this.$refs.dataViewer?.openAddModal();
        },

        // 외부에서 탭 전환 (선택적)
        switchToTab(tabIndex) {
            this.activeTab = tabIndex;
        },

        // 업로드 데이터 초기화
        clearUploadData() {
            if (this.$refs.uploader) {
                this.$refs.uploader.clearData();
                this.hasUploadedFile = false;
                this.uploadedFileName = "";
                this.uploadedFileSize = "";
            }
        },

        // 업로드된 파일 상태 체크
        checkUploadedFile() {
            if (this.$refs.uploader && this.$refs.uploader.selectedFile) {
                this.hasUploadedFile = true;
                this.uploadedFileName = this.$refs.uploader.selectedFile.name;
                this.uploadedFileSize = this.formatFileSize(this.$refs.uploader.selectedFile.size);
            } else {
                this.hasUploadedFile = false;
                this.uploadedFileName = "";
                this.uploadedFileSize = "";
            }
        },

        // 파일 선택 트리거
        triggerFileSelect() {
            if (this.$refs.uploader) {
                this.$refs.uploader.triggerFileSelect();
            }
        },

        // 파일 제거
        removeFile() {
            this.clearUploadData();
        },

        // 기간 포맷 (YYYYMM → YYYY.MM)
        formatFixedPeriod(period) {
            if (!period) return "";
            const str = String(period).replace(/-/g, "");
            if (str.length >= 6) return `${str.slice(0, 4)}.${str.slice(4, 6)}`;
            return str;
        },

        // 파일 크기 포맷팅
        formatFileSize(bytes) {
            if (bytes === 0) return "0 Bytes";
            const k = 1024;
            const sizes = ["Bytes", "KB", "MB", "GB"];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
        },
    },
};
</script>

<style scoped>
/* 메인 레이아웃 */
.activity-data-manager-compact {
    padding: 0px 16px;
}

/* 탭 액션 그룹 */
.tab-actions-group {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* 기간 고정 noti (파일 선택 버튼 왼쪽) */
.fixed-period-noti {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    font-size: 11px;
    color: #1e40af;
    background: #eff6ff;
    border: 1px solid #93c5fd;
    border-radius: 4px;
}

.fixed-period-noti i {
    font-size: 10px;
    color: #3b82f6;
}

/* 파일 선택/정보 영역 */
.file-compact-area {
    display: flex;
    align-items: center;
}

.btn-file-select {
    padding: 6px 12px;
    background: #ffffff;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-size: 13px;
    color: #52b788;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;
}

.btn-file-select:hover {
    background: #f0fdf4;
    border-color: #52b788;
    color: #40916c;
}

.file-info-compact {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 13px;
    max-width: 400px;
}

.file-icon-small {
    color: #52b788;
    font-size: 14px;
    flex-shrink: 0;
}

.file-name-small {
    color: #1e293b;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 250px;
}

.file-size-small {
    color: #64748b;
    font-size: 12px;
    flex-shrink: 0;
}

.btn-icon-tiny {
    width: 20px;
    height: 20px;
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 4px;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.btn-icon-tiny:hover {
    background: #fee2e2;
    color: #dc2626;
}

/* 탭 컨텐츠 */
.tab-content-wrapper {
    min-height: 400px;
}

.tab-pane {
    animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

/* 반응형 */
@media (max-width: 768px) {
    .activity-data-manager-compact {
        padding: 0px 16px;
    }

    .tab-actions-group {
        width: 100%;
    }

    .tab-actions-group button {
        flex: 1;
    }
}
</style>
